export const FETCH_LINKED_USERS = 'FETCH_LINKED_USERS';
export const STORE_LINKED_USERS = 'STORE_LINKED_USERS';
export const EDIT_USER = 'EDIT_USER';
export const DELETE_USER = 'DELETE_USER'

export const GET_ROLES = 'GET_ROLES'
export const STORE_ROLES = 'STORE_ROLES'